// @module StellarGrade.ST_Facets.FacetsBrowseCategoryHeading.View
define('StellarGrade.ST_Facets.FacetsBrowseCategoryHeading.View', [
    'Facets.Browse.CategoryHeading.View',
    'stellargrade_st_facets_facetsbrowsecategoryheading.tpl',
    'underscore',
    'jQuery',
    'Utils',
], function (FacetsBrowseCategoryHeadingView, stellargrade_st_facets_FacetsBrowseCategoryHeading_tpl, _, $, Utils) {
    'use strict';

    return {
        loadModule: function () {
            _.extend(FacetsBrowseCategoryHeadingView.prototype, {
                template: stellargrade_st_facets_FacetsBrowseCategoryHeading_tpl,

                getContext: _.wrap(FacetsBrowseCategoryHeadingView.prototype.getContext, function wrapper(fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    var flyoutMarkup = '';
                    var currentDomain = window.location.origin;
                    var lpcImageUrl = currentDomain + '/Product Images/LPC-Buyers-Guide_rev2.png';
                    var displaysImageUrl = currentDomain + '/Product Images/Displays-Monitors.png';
                    context.isLittlePC = false;
                    context.isPanelPc = false;
                    context.isDisplay = false;

                    var fullurl = this.model.attributes.fullurl;
                    if (fullurl.indexOf('/PRODUCTS_CATEGORIES/LittlePC') !== -1) {
                        flyoutMarkup =
                            '<div class="facets-category-cell" id="spc-flyout">\
                                <button class="spc-flyout-minimize">–</button>\
                                <div class="spc-flyout-content">\
                                    <a class="facets-category-cell-anchor" href="https://www.stealth.com/wp-content/uploads/2025/07/LPC-Buyers-Guide-FV.pdf" target="_blank">\
                                        <img class="facets-category-cell-image" src="' +
                            lpcImageUrl +
                            '" alt="LPC Buyer\'s Guide" />\
                                        <div class="facets-category-cell-title">LPC Buyer\'s Guide</div>\
                                    </a>\
                                </div>\
                                <div class="spc-flyout-minimized-title">Buyer\'s Guide</div>\
                            </div>';
                    } else if (fullurl.indexOf('/PRODUCTS_CATEGORIES/Displays') !== -1) {
                        flyoutMarkup =
                            '<div class="facets-category-cell" id="spc-flyout">\
                                <button class="spc-flyout-minimize">–</button>\
                                <div class="spc-flyout-content">\
                                    <a class="facets-category-cell-anchor" href="https://www.stealth.com/wp-content/uploads/2025/06/Stealth-Rugged-Displays-Monitors-Buyers-Guide.pdf" target="_blank">\
                                        <img class="facets-category-cell-image" src="' +
                            displaysImageUrl +
                            '" alt="Displays Buyer\'s Guide" />\
                                        <div class="facets-category-cell-title">Displays Buyer\'s Guide</div>\
                                    </a>\
                                </div>\
                                <div class="spc-flyout-minimized-title">Buyer\'s Guide</div>\
                            </div>';
                    } else if (fullurl.indexOf('PRODUCTS_CATEGORIES/QuickShip') !== -1) {
                        context.isQuickShip = true;

                        var quickShipCell =
                            '<div class="facets-category-cell custom-quickship-cell">' +
                            '<div class="facets-category-cell-anchor">' +
                            '<img src="https://439653.app.netsuite.com/core/media/media.nl?id=8336912&c=439653&h=P-2c0f-aSp5ZFX6CrPpd3i1O9D4VS2Yx62sOBsdtVF9yAcba" ' +
                            'alt="Stealth Quick Ship" class="facets-category-cell-image" />' +
                            '</div>' +
                            '</div>';

                        setTimeout(function () {
                            var $quickShipCell = $('.facets-browse-category-heading-main-description');

                            if ($quickShipCell.length && !$quickShipCell.find('.custom-panelpc-cell').length) {
                                $quickShipCell.append(quickShipCell);
                            }
                        }, 10);
                    }
                    setTimeout(function () {
                        if (context.name === 'Clearance') {
                            $('.facets-browse-category-heading-main-title').css('color', '#E31B23');
                        }
                    }, 100);

                    if (flyoutMarkup) {
                        setTimeout(function () {
                            if (!document.getElementById('spc-flyout')) {
                                $('.facets-facet-browse-category-cells-container').append(flyoutMarkup);
                            }
                        }, 5000);
                    }

                    return context;
                }),
            });

            $(document).on('click', '.spc-flyout-minimize', function () {
                var $flyout = $('#spc-flyout');
                var $button = $(this);
                $button.hide();
                $flyout.addClass('spc-minimized');
                $flyout.off('mouseenter mouseleave');
                $flyout.on('mouseenter', function () {
                    $(this).removeClass('spc-minimized');
                });
                $flyout.on('mouseleave', function () {
                    $(this).addClass('spc-minimized');
                });
            });
        },
    };
});
